import { IconDatabaseOutline18 as Database } from "nucleo-ui-outline-18"

import { GitHubIcon } from "@productlane/ui/src/icons/project/github-icon"
import { LinearIcon } from "@productlane/ui/src/icons/project/linear-icon"

import { MetaInfo } from "@/components/meta-info"
import { SettingsHeader } from "../settings-header"
import { AiCustomPromptSection } from "./ai-custom-prompt-section"
import { aiSettingsGroupClass, AiSettingsRow } from "./ai-settings-row"

export function AiAssistantPage() {
	return (
		<>
			<MetaInfo title="AI Assistant Settings" />

			<SettingsHeader
				title="AI Assistant"
				subtitle="An in-thread assistant that researches and drafts alongside you."
			/>

			<div className="mb-3 flex items-center gap-2">
				<span className="text-sm font-medium text-primary">Integrations</span>
			</div>
			<div className={`${aiSettingsGroupClass} mb-8`}>
				<AiSettingsRow
					icon={LinearIcon}
					title="Linear"
					description="Connect Linear so the AI Assistant can file and link issues from a thread."
					link="/settings/integrations/linear"
				/>
				<AiSettingsRow
					icon={GitHubIcon}
					title="GitHub"
					description="Connect GitHub so the AI Assistant can ground drafts in merged commits and closed issues."
					link="/settings/integrations/github"
				/>
				<AiSettingsRow
					icon={Database}
					title="PostgreSQL"
					description="Connect a database so the AI Assistant can answer with read-only queries."
					link="/settings/integrations/postgres"
				/>
			</div>

			<AiCustomPromptSection />
		</>
	)
}
